//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { WorkOrderSource, WorkOrderType } from '../../../../store/entities/workOrder'

export default {
    name: "page-transferOrder-view",
    data() {
        return {
            WorkOrderSource,
            WorkOrderType,
            dispatchPopup: false,
            paiGongPopup: false,
            saving: false,
            paiDanInputDto: {
                smsChecked: false
            },
            departments: [],
            departmentUser: [],
            organizationUnitAllUsers: [],
            showDispachist: false,
            showDepartmentUser: false,
            wuYeUserPopup: false,
            wuYeUsers: [],
            paiDanReturnOrderPopup: false,
            paiDanReturnOrder: {}
        }
    },
    props: {
        value: Boolean,
        operatorId: {
            required: true
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        },
    },
    methods: {
        getDepartments() {
            if (this.workOrderInfo.organizationId === 0 || this.workOrderInfo.organizationId === undefined) {
                // this.$toast.fail("项目没有绑定组织结构")
                return;
            }
            abp.ajax.get('/api/services/app/OrganizationUnit/GetDepartmentsByParentId?parentId=' + this.workOrderInfo.organizationId).then(res => {
                this.departments = [];
                this.departments = res.data.result;

            }).finally(() => {
            });
        },

        getDepartmentUser(organizationId) {
            if (this.workOrderInfo.organizationId === 0) {
                // this.$toast.fail("项目没有绑定组织结构")
                return;
            }
            abp.ajax.get('/api/services/app/OrganizationUnit/GetDepartmentUser?organizationId=' + organizationId).then(res => {
                this.departmentUser = {};
                this.departmentUser = res.data.result;
                this.departmentUser.forEach(item => {
                    item.text = item.name;
                })

            }).finally(() => {
            });
        },
        onPaidanDepartmentConfirm(val) {
            this.paiDanInputDto.dutyDepartment = val.id;
            this.paiDanInputDto.departmentName = val.name;
            this.paiDanInputDto.dutyPerson = 0;
            this.paiDanInputDto.name = '';
            this.paiDanInputDto.phoneNumber = '';
            this.departmentUser = [];
            this.getDepartmentUser(val.id);
            this.showDispachist = false;
        },
        onPaidanUserConfirm(val) {
            // console.log(val);
            this.paiDanInputDto.dutyPerson = val.id;
            this.paiDanInputDto.name = val.name;
            this.paiDanInputDto.phoneNumber = val.phoneNumber;
            this.showDepartmentUser = false;

        },

        onSave() {
            this.paiDanInputDto.workOrderId = this.workOrderInfo.id;
            // console.log(this.paiDanInputDto)
            // this.$emit('handleSuccess')
            // this.$emit('handleCancel')
            abp.ajax.post('/api/services/app/WorkOrder/MSaveTransferOrder', this.paiDanInputDto).then(res => {

                this.$emit('handleSuccess')
                this.$emit('handleCancel')
            }).finally(() => {
                this.saving = false;
            });
        },
        onCancel() {
            this.$emit('handleCancel')
        },
        onSuccess() {
            this.$emit('handleSuccess')
        },


    },
    created() {
        this.getDepartments(); //获取部门
    }
}
